import React, { ReactElement } from 'react';
import Dropdown from './component/Dropdown';
import Uuid from '../../model/Uuid';

interface Props {
  assignedList?: Array<Uuid>;
  setAssignedList?: (assignedList: Array<Uuid>) => void;
  reloadSubjektBezPripomienokList?(): void;
  reloadPripomienkyList?(): void;
  reloadFilterData?(): void;
}

const ActionButton = ({
  assignedList,
  setAssignedList,
  reloadPripomienkyList,
  reloadSubjektBezPripomienokList,
  reloadFilterData,
}: Props): ReactElement => (
  <Dropdown
    title="Možnosti"
    reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
    assignedList={assignedList}
    setAssignedList={setAssignedList}
    reloadPripomienkyList={reloadPripomienkyList}
    reloadFilterData={reloadFilterData}
  />
);
export default ActionButton;
